import React, { useEffect, useRef } from 'react';
import Spinner from 'react-bootstrap/Spinner';

export default function WaitingForRun({ threadId, runId, onRunComplete }) {
  const timeoutRef = useRef();

  useEffect(() => {
    let isMounted = true;

    const pollStatus = async () => {
      try {
        const response = await fetch(`/api/threads/${threadId}/runs/${runId}`);
        if (!response.ok) throw new Error('Network response was not ok');
        const data = await response.json();
        console.log('WaitingForRun.pollStatus: data = ', data)
        if (data.remote_status === 'completed') {
          if (timeoutRef.current) clearTimeout(timeoutRef.current);
          if (isMounted) onRunComplete();
        } else {
          // Poll again after 2 seconds
          timeoutRef.current = setTimeout(pollStatus, 2000);
        }
      } catch (error) {
        // Optionally handle error, and retry
        timeoutRef.current = setTimeout(pollStatus, 2000);
      }
    };

    pollStatus();

    return () => {
      isMounted = false;
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [threadId, runId, onRunComplete]);

  return (
    <Spinner />
  );
} 
